import classNames from "classnames";
import { PropsWithChildren } from "react";

/** Creates a single "row" in a multi-line cell display.
 *
 * This row clips text with an ellipsis. Use with a {@link GraphTooltip}
 * to expand ellipsis content.
 */
export const CellInner: React.FC<PropsWithChildren<{ className?: string }>> = ({
  children,
  className,
}) => (
  <div className={classNames("overflow-x-clip text-ellipsis", className)}>
    {children}
  </div>
);
